const ConditionalWrapper = <T,>({
  when,
  children,
  wrapper,
}: {
  when: T
  children: React.ReactNode
  wrapper: (children: React.ReactNode, value: NonNullable<T>) => React.ReactNode
}) => {
  if (when) {
    return wrapper(children, when)
  }
  return children
}

export default ConditionalWrapper
